import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AgentLayout from "../components/AgentLayout";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import UserNavigation from "../users/user-navigation";
import { useNavigate } from 'react-router-dom';
import { isMobile } from "react-device-detect";
const AccountEdit = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userStore);
  //console.log("userinfo:", userInfo);
  const [messageLimit, setMessageLimit] = useState({
    status: false,
    message: ""
  });
  const [messageProfile, setMessageProfile] = useState({
    status: false,
    message: ""
  });

  const [staticId, setStaticId] = useState("");
  const [displayUsername, setDisplayUsername] = useState("");
  const [currency, setCurrency] = useState("");
  const [role, setRole] = useState("");
  const [phone, setPhone] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [betStatus, setBetStatus] = useState(false);
  const [canSettled, setCanSettled] = useState(false);
  const [allowAutoDeposit, setAllowAutoDeposit] = useState(false);
  const [pageLoad, setPageLoad] = useState(false);
  const [animation, handleAnimation] = useState(false);
  const [animationLimit, handleAnimationLimit] = useState(false);

  const [userPlainPassword, setUserPlainPassword] = useState("");

  const [soccer, handleSoccer] = useState({ soccer: 0, soccerOld: 0 });
  const [tennis, handleTennis] = useState({ tennis: 0, tennisOld: 0 });
  const [cricket, handleCricket] = useState({ cricket: 0, cricketOld: 0 });
  const [fancy, handleFancy] = useState({ fancy: 0, fancyOld: 0 });
  const [hrace, handleHrace] = useState({ hrace: 0, hraceOld: 0 });
  const [greyhound, handleGreyhound] = useState({
    greyhound: 0,
    greyhoundOld: 0
  });
  const [bookMaker, handleBookMaker] = useState({
    bookMaker: 0,
    bookMakerOld: 0
  });

  const [teenpatiStudio, handleTeenpatiStudio] = useState({
    teenpatiStudio: 0,
    teenpatiStudioOld: 0
  });

  const [galaxyStudio, handleGalaxy] = useState({
    galaxyStudio: 0,
    galaxyStudioOld: 0
  });

  const [betfair, handleBetfair] = useState({
    betfair: 0,
    betfairOld: 0
  });

  const [casino, handleCasino] = useState({ casino: 0, casinoOld: 0 });

  useEffect(() => {
    const fetchUserById = async () => {
      if (!userId) return;
      try {
        const response = await axiosInstance.get("user/" + userId);
        if (response?.data) {
          setStaticId(response.data?._id);
          setDisplayUsername(response.data?.uname);
          setCurrency(response.data?.currency);
          setRole(response.data?.user_role);
          setPhone(response.data?.mobno);
          setIsActive(response.data?.stat);
          setBetStatus(response.data?.bet_status);
          setCanSettled(response.data?.can_settled);
          setAllowAutoDeposit(!!response.data?.allow_auto_deposit);

          setUserPlainPassword(response.data?.passpinTxt);
        }
        const betLimit = await axiosInstance.get(
          "company/get-bet-limit/" + userId
        );
        const limitObj = betLimit?.data?.betlmit;
        if (limitObj) {
          handleSoccer({
            soccer: Number(limitObj.soccer) || 0,
            soccerOld: Number(limitObj.soccer) || 0
          });
          handleTennis({
            tennis: Number(limitObj.tennis) || 0,
            tennisOld: Number(limitObj.tennis) || 0
          });
          handleCricket({
            cricket: Number(limitObj.cricket) || 0,
            cricketOld: Number(limitObj.cricket) || 0
          });
          handleFancy({
            fancy: Number(limitObj.fancy) || 0,
            fancyOld: Number(limitObj.fancy) || 0
          });
          handleCasino({
            casino: Number(limitObj.casino) || 0,
            casinoOld: Number(limitObj.casino) || 0
          });

          handleGreyhound({
            greyhound: Number(limitObj.greyhound) || 0,
            greyhoundOld: Number(limitObj.greyhound) || 0
          });

          handleBookMaker({
            bookMaker: Number(limitObj.bookMaker) || 0,
            bookMakerOld: Number(limitObj.bookMaker) || 0
          });

          handleHrace({
            hrace: Number(limitObj.hrace) || 0,
            hraceOld: Number(limitObj.hrace) || 0
          });

          handleTeenpatiStudio({
            teenpatiStudio: Number(limitObj.teenpatiStudio) || 0,
            teenpatiStudioOld: Number(limitObj.teenpatiStudio) || 0
          });

          handleGalaxy({
            galaxyStudio: Number(limitObj.galaxyStudio) || 0,
            galaxyStudioOld: Number(limitObj.galaxyStudio) || 0
          });

          handleBetfair({
            betfair: Number(limitObj.betfair) || 0,
            betfairOld: Number(limitObj.betfair) || 0
          });
        }
      } catch (error) {
        console.error("Error fetching user for edit:", error);
      } finally {
        setPageLoad(true);
      }
    };
    fetchUserById();
  }, [userId]);

  const handleIsActiveCheckbox = (e) => {
    var isActive = e.target.checked;
    setIsActive(isActive);
  };

  const [betStatusMsg, setBetStatusMsg] = useState("");
  const canManageBetting = !!userInfo.data?.bet_status;
  //const canManageBetting = true;
  const canManageSettle = !!userInfo.data?.can_settled;
  const canManageAutoDeposit = !!userInfo.data?.allow_auto_deposit;

  const handleBettingCheckbox = (e) => {
    if (!canManageBetting) {
      setBetStatusMsg("You cannot change betting status");
      e.preventDefault();
      return;
    }
    setBetStatusMsg("");
    var betting = e.target.checked;
    setBetStatus(betting);
  };

  const [canSettleMsg, setCanSettleMsg] = useState("");

  const handleCanSettledheckbox = (e) => {
    if (!canManageSettle) {
      setCanSettleMsg("You cannot settle PL");
      e.preventDefault();
      return;
    }
    setCanSettleMsg("");
    var settled = e.target.checked;
    setCanSettled(settled);
  };

  const [allowAutoDepositMsg, setAllowAutoDepositMsg] = useState("");

  const handleAllowAutoDepositCheckbox = (e) => {
    if (!canManageAutoDeposit) {
      setAllowAutoDepositMsg("You cannot change auto deposit permission");
      e.preventDefault();
      return;
    }
    setAllowAutoDepositMsg("");
    setAllowAutoDeposit(e.target.checked);
  };

  const [password, setPassword] = useState("");
  const handlePassword = (e) => {
    var password = e.target.value;
    setPassword(password);
  };

  const handlePhone = (e) => {
    var phone = e.target.value;
    setPhone(phone);
  };

  const [reference, setReference] = useState("");
  const handleReference = (e) => {
    var referenceValue = e.target.value;
    setReference(referenceValue);
  };

  const [note, setNote] = useState("");
  const handleNote = (e) => {
    var noteValue = e.target.value;
    setNote(noteValue);
  };

  const getClipBoardText = async (username, password, role) => {
    let txtRole = "";
    if (role == 2) {
      txtRole = "SuperCompany";
    } else if (role == 3) {
      txtRole = "Company";
    } else if (role == 4) {
      txtRole = "Super Admin";
    } else if (role == 5) {
      txtRole = "Admin";
    } else if (role == 6) {
      txtRole = "SuperMaster";
    } else if (role == 7) {
      txtRole = "Master";
    } else if (role == 8) {
      txtRole = "Bettor";
    }
    let copyTxt = "Username: " + username + "\n";
    copyTxt += "Password: " + password + "\n";
    copyTxt += "Role: " + txtRole + "\n";
    copyTxt += "URL: https://bpexch.me";

    navigator.clipboard.writeText(copyTxt);
  };

  const handleSaveUserData = async () => {
    var userObj = {};
    userObj.passpin = password;
    userObj.stat = isActive ? 1 : 0;
    if (canManageBetting) {
      userObj.bet_status = betStatus ? 1 : 0;
    }
    if (canManageSettle) {
      userObj.can_settled = canSettled ? 1 : 0;
    }
    if (canManageAutoDeposit) {
      userObj.allow_auto_deposit = allowAutoDeposit ? 1 : 0;
    }
    userObj.mobno = phone;
    userObj.reference = reference;
    userObj.note = note;
    userObj.UserDomain = "bpexch.me";
    handleAnimation(true);
    setMessageProfile({ status: false, message: "" });

    try {
      const response = await axiosInstance.post(
        "/company/update-user/" + userId,
        userObj
      );
      if (
        response !== null &&
        response !== undefined &&
        response.data !== null &&
        response.data !== undefined
      ) {
        if (
          response.data.message !== null &&
          response.data.message !== undefined &&
          response.data.status === true
        ) {
          handleAnimation(false);
          navigate("/agent/edit/" + userId);
          setPassword("");
          if (password != "") {
            getClipBoardText(displayUsername, password, role);
          }

          //setMessageProfile({ status: true, message: response.data.message });
        }
      }
    } catch (error) {
      // let errorData =error.response.data;
      let errorMessage = error.response.data.message;
      handleAnimation(true);
      setMessageProfile({ status: false, message: errorMessage });
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const haldelShowPassword = async (stat) => {
    if (stat) {
      setPassword(userPlainPassword);
    } else {
      setPassword("");
    }

    setShowPassword(stat);
  };

  const handleSaveBetLimit = async () => {
    handleAnimationLimit(true);
    setMessageLimit({ status: false, message: "" });
    var userObj = {};

    userObj.soccer = soccer.soccer;
    userObj.tennis = tennis.tennis;
    userObj.cricket = cricket.cricket;
    userObj.fancy = fancy.fancy;
    userObj.hrace = hrace.hrace;
    userObj.casino = casino.casino;
    userObj.greyhound = greyhound.greyhound;
    userObj.bookMaker = bookMaker.bookMaker;
    userObj.teenpatiStudio = teenpatiStudio.teenpatiStudio;
    userObj.galaxyStudio = galaxyStudio.galaxyStudio;
    userObj.betfair = betfair.betfair;

    try {
      const response = await axiosInstance.post(
        "/company/save-bet-limit/" + userId,
        userObj
      );
      if (
        response !== null &&
        response !== undefined &&
        response.data !== null &&
        response.data !== undefined
      ) {
        if (
          response.data.message !== null &&
          response.data.message !== undefined &&
          response.data.status === true
        ) {
          handleAnimationLimit(false);
          navigate("/agent/edit/" + userId);
          //setMessageLimit({ status: true, message: response.data.message });
        }
      }
    } catch (error) {
      if (error.response.data !== null && error.response.data.message !== "") {
        let errorMessage = error.response.data.message;
        setMessageLimit({ status: false, message: errorMessage });
      }

      handleAnimationLimit(false);
    }
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const getCurrency = (currency) => {
    let currencyValue = "";
    if (currency === 1) {
      currencyValue = "Rs.";
    } else if (currency === 2) {
      currencyValue = "PKR";
    } else if (currency === 3) {
      currencyValue = "AED";
    } else if (currency === 4) {
      currencyValue = "USD";
    }
    return currencyValue;
  };

  const getUserRole = (role) => {
    let roleName = "";
    if (role === 1) {
      roleName = "Owner Company";
    } else if (role === 2) {
      roleName = "Super Company";
    } else if (role === 3) {
      roleName = "Company";
    } else if (role === 4) {
      roleName = "Superadmin";
    } else if (role === 5) {
      roleName = "Admin";
    } else if (role === 6) {
      roleName = "Super Master";
    } else if (role === 7) {
      roleName = "Master";
    } else if (role === 8) {
      roleName = "Bettor";
    }
    return roleName;
  };

  return (
    <AgentLayout>
      <style>
        {`
                <style>
              .btn-success {
                color: #fff;
                background-color: #00b181;
                border-color: #28a745;
              }

              .btn_top {
                display: inline-block;
                font-weight: 400;
                text-align: center;
                white-space: nowrap;
                vertical-align: middle;
                user-select: none;
                border: 1px solid transparent;
                padding: .375rem .75rem;
                font-size: .875rem;
                line-height: 1.5;
                border-radius: .25rem;
                transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
              }

              .password-wrapper {
                position: relative;
                width: 100%;
              }
              
              .password-eye {
                position: absolute;
                right: 12px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                color: #495057;
                z-index: 2;
              }
            </style>
                `}
      </style>

      <div class="right-content-wrapper" style={{ background: "transparent" }}>
        <div class="bets-section-wrapper">
          <div class="row">
            <div class="col-12">
              <UserNavigation
                displayUsername={displayUsername}
              ></UserNavigation>
            </div>
            <div
              class="col-12 col-md-6"
              style={{ display: pageLoad ? "" : "none", marginTop: "40px" }}
            >
              <div
                class="card"
                style={{ marginLeft: "5px", marginBottom: "-0.5rem" }}
              >
                <div class="card-header site_family">
                  {" "}
                  Edit Client - <strong>{displayUsername}</strong>
                </div>
                <div class="card-body">
                  <div
                    class="form-group row"
                    style={{
                      display: messageProfile.status != "" ? "" : "none"
                    }}
                  >
                    <label class="col-4 col-md-3 col-form-label"></label>
                    <div
                      class="col-8 col-md-6"
                      style={{
                        fontWeight: "bold",
                        color: messageProfile.status ? "green" : "red"
                      }}
                    >
                      {messageProfile.message}
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        ID
                      </label>
                      <div class="col-8 col-md-6">
                        <p class="form-control-static site_family">
                          {staticId?.slice(-7)}
                        </p>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Username
                      </label>
                      <div class="col-8 col-md-6">
                        <p class="form-control-static site_family">
                          {displayUsername}
                        </p>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Type
                      </label>
                      <div class="col-8 col-md-6">
                        <p class="form-control-static site_family">
                          {getUserRole(role)}{" "}
                        </p>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Currency
                      </label>
                      <div class="col-8 col-md-6">
                        <p class="form-control-static site_family">
                          {getCurrency(currency)}
                        </p>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Password
                      </label>
                      <div className="col-8 col-md-6">
                        <div className="password-wrapper">
                          <input
                            className="form-control site_family"
                            type={showPassword ? "text" : "password"}
                            onChange={handlePassword}
                            value={password}
                            style={{
                              fontSize: "1rem",
                              fontWeight: "400",
                              color: "#495057",
                              height: "calc(1.5em + .75rem + 2px)",
                              paddingRight: "40px"
                            }}
                          />

                          <i
                            onClick={() => haldelShowPassword(!showPassword)}
                            className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"
                              } password-eye`}
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        class="col-4 col-md-3 col-form-label site_family"
                        for="stat"
                      >
                        IsActive
                      </label>
                      <div class="col-8 col-md-6 col-form-label">
                        <div class="form-check checkbox">
                          <input
                            class="form-check-input site_family"
                            style={{ width: "15px", height: "15px" }}
                            type="checkbox"
                            onChange={handleIsActiveCheckbox}
                            value="true"
                            checked={isActive}
                          />
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label
                        class="col-4 col-md-3 col-form-label site_family"
                        for="user_CanBet"
                      >
                        {" "}
                        Betting Allowed
                      </label>
                      <div class="col-8 col-md-6 col-form-label">
                        <div class="form-check checkbox d-block">
                          <div className="d-block w-100">
                            <input
                              class="form-check-input"
                              style={{ width: "15px", height: "15px" }}
                              onChange={handleBettingCheckbox}
                              type="checkbox"
                              value="true"
                              checked={betStatus}
                            />
                          </div>
                          {betStatusMsg && (
                            <div
                              className="d-block text-danger w-100"
                              style={{ fontSize: "13px" }}
                            >
                              {betStatusMsg}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {canManageSettle && (
                      <div class="form-group row">
                        <label class="col-4 col-md-3 col-form-label site_family">
                          {" "}
                          Can Settle PL{" "}
                        </label>
                        <div class="col-8 col-md-6 col-form-label">
                          <div class="form-check checkbox">
                            <input
                              class="form-check-input"
                              style={{ width: "15px", height: "15px" }}
                              onChange={handleCanSettledheckbox}
                              type="checkbox"
                              checked={canSettled}
                            />
                            <label
                              class="form-check-label site_family"
                              style={{ paddingLeft: "5px", paddingTop: "3px" }}
                            >
                              {" "}
                              Enable S button{" "}
                            </label>
                          </div>
                          {canSettleMsg && (
                            <div
                              class="text-danger mt-1"
                              style={{ fontSize: "13px" }}
                            >
                              {canSettleMsg}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {canManageAutoDeposit && (
                      <div class="form-group row">
                        <label class="col-4 col-md-3 col-form-label site_family">
                          {" "}
                          Allow Auto Deposit{" "}
                        </label>
                        <div class="col-8 col-md-6 col-form-label">
                          <div class="form-check checkbox">
                            <input
                              class="form-check-input"
                              style={{ width: "15px", height: "15px" }}
                              onChange={handleAllowAutoDepositCheckbox}
                              type="checkbox"
                              checked={allowAutoDeposit}
                            />
                          </div>
                          {allowAutoDepositMsg && (
                            <div
                              class="text-danger mt-1"
                              style={{ fontSize: "13px" }}
                            >
                              {allowAutoDepositMsg}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div class="form-group row">
                      <label
                        class="col-4 col-md-3 col-form-label site_family"
                        for="mobno"
                      >
                        Phone
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control"
                          type="text"
                          onChange={handlePhone}
                          value={phone}
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-4 col-md-3 col-form-label site_family"
                        for="reference"
                      >
                        Reference
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control"
                          type="text"
                          onChange={handleReference}
                          value={reference}
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-4 col-md-3 col-form-label site_family"
                        for="note"
                      >
                        Notes
                      </label>
                      <div class="col-8 col-md-6">
                        <textarea
                          class="form-control"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057"
                          }}
                          onChange={handleNote}
                          value={note}
                        ></textarea>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-4 col-md-3 col-form-label site_family"
                        for="commission"
                      >
                        Commission
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          type="number"
                          step="0.01"
                          class="form-control"
                          min="2.00"
                          readonly=""
                          data-val="true"
                          data-val-number="The field Commission must be a number."
                          data-val-required="The Commission field is required."
                          id="commission"
                          name="commission"
                          value="2"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                        />
                        <span class="help-block site_family">
                          Min commission is 2.00 %
                        </span>
                        <span
                          class="field-validation-valid"
                          data-valmsg-for="commission"
                          data-valmsg-replace="true"
                        ></span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-4 col-md-3 col-form-label site_family"
                        for="commission"
                      >
                        UserDomain
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          class="form-control"
                          readonly=""
                          id="UserDomain"
                          name="UserDomain"
                          value="1  ( bpexch.me )"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: "30px",
                      marginBottom: "10px",
                      textAlign: "right"
                    }}
                  >
                    <button
                      className="btn btn-primary editsbmtbtnin"
                      style={{
                        display: animation ? "none" : "inline-block"
                      }}
                      type="button"
                      onClick={handleSaveUserData}
                    >
                      <strong className="site_family">Submit</strong>
                    </button>
                  </div>

                  <button
                    type="button"
                    class="btn btn-primary editsbmtbtnin"
                    style={{
                      border: "0px",
                      cursor: "pointer",
                      display: animation ? "" : "none"
                    }}
                  >
                    <div className="site_family">
                      Submit{" "}
                      {/*<div class="ld ld-ball ld-flip" id="bp_loader_web"></div>*/}
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-6"
              style={{ display: pageLoad ? "" : "none", marginTop: "40px" }}
            >
              <div>
                <div class="validation-summary-valid"></div>
                <div class="card" style={{ marginRight: "5px" }}>
                  <div class="card-header">
                    <strong className="site_family">Max Bet Sizes</strong>
                  </div>
                  <div class="card-body">
                    <div
                      class="form-group row"
                      style={{
                        display: messageLimit.status != "" ? "" : "none"
                      }}
                    >
                      <label class="col-4 col-md-3 col-form-label"></label>
                      <div
                        class="col-8 col-md-6 site_family"
                        style={{
                          fontWeight: "bold",
                          color: messageLimit.status ? "green" : "red"
                        }}
                      >
                        {messageLimit.message}
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Soccer
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          onChange={(e) =>
                            handleSoccer({
                              ...soccer,
                              soccer:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={soccer.soccer}
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(soccer.soccerOld)}
                        </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Tennis
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          value={tennis.tennis}
                          onChange={(e) =>
                            handleTennis({
                              ...tennis,
                              tennis:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(tennis.tennisOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Cricket
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          onChange={(e) =>
                            handleCricket({
                              ...cricket,
                              cricket:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={cricket.cricket}
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(cricket.cricketOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Fancy
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          onChange={(e) =>
                            handleFancy({
                              ...fancy,
                              fancy:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={fancy.fancy}
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(fancy.fancyOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Races
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          onChange={(e) =>
                            handleHrace({
                              ...hrace,
                              hrace:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={hrace.hrace}
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(hrace.hraceOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Casino
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          type="text"
                          onChange={(e) =>
                            handleCasino({
                              ...casino,
                              casino:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={casino.casino}
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(casino.casinoOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Greyhound
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          type="text"
                          onChange={(e) =>
                            handleGreyhound({
                              ...greyhound,
                              greyhound:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={greyhound.greyhound}
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(greyhound.greyhoundOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        BookMaker
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          onChange={(e) =>
                            handleBookMaker({
                              ...bookMaker,
                              bookMaker:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={bookMaker.bookMaker}
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(bookMaker.bookMakerOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Teenpati Studio
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          onChange={(e) =>
                            handleTeenpatiStudio({
                              ...teenpatiStudio,
                              teenpatiStudio:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={teenpatiStudio.teenpatiStudio}
                        />
                        <span class="field-validation-valid site_family">
                          Max:{" "}
                          {formatTruncate(teenpatiStudio.teenpatiStudioOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Galaxy Studio
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          onChange={(e) =>
                            handleGalaxy({
                              ...galaxyStudio,
                              galaxyStudio:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={galaxyStudio.galaxyStudio}
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(galaxyStudio.galaxyStudioOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        Betfair Games
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          type="text"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          onChange={(e) =>
                            handleBetfair({
                              ...betfair,
                              betfair:
                                e.target.value > 0 && Number(e.target.value)
                                  ? Number(e.target.value)
                                  : 0
                            })
                          }
                          value={betfair.betfair}
                        />
                        <span class="field-validation-valid site_family">
                          Max: {formatTruncate(betfair.betfairOld)}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-md-3 col-form-label site_family">
                        T-PIN
                      </label>
                      <div class="col-8 col-md-6">
                        <input
                          class="form-control site_family"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "400",
                            color: "#495057",
                            height: "calc(1.5em + .75rem + 2px)"
                          }}
                          type="number"
                          value=""
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        marginTop: "20px",
                        marginBottom: "20px",
                        textAlign: "right"
                      }}
                    >
                      <button
                        className="btn btn-primary editsbmtbtnin"
                        style={{
                          display: animation ? "none" : "inline-block"
                        }}
                        type="button"
                        onClick={handleSaveBetLimit}
                      >
                        <strong className="site_family">Submit</strong>
                      </button>
                    </div>

                    <button
                      type="button"
                      class="btn btn-primary editsbmtbtnin site_family"
                      style={{
                        cursor: "pointer",
                        display: animationLimit ? "" : "none"
                      }}
                    >
                      <div>
                        Submit{" "}
                        {/*<div
                          class="ld ld-ball ld-flip"
                          id="bp_loader_web"
                    ></div>*/}
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                textAlign: "center",
                display: pageLoad ? "none" : "block"
              }}
            >
              <img src="../../assets/images/loadinggif.gif" alt="Loader" />
            </div>
          </div>
        </div>
      </div>
    </AgentLayout>
  );
};

export default AccountEdit;